import { useEffect, useRef } from "react";
import "./App.css";
import axios from "axios";
import { initAnalytics, trackPageview } from "./lib/analytics";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Munkaink from "./pages/Munkaink";
import CategoryPage from "./pages/CategoryPage";
import ProjectPage from "./pages/ProjectPage";
import Rolunk from "./pages/Rolunk";
import ThankYou from "./pages/ThankYou";
import AdminPage from "./pages/AdminPage";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  const isFirstLoad = useRef(true);

  // Meta Pixel: PageView minden útvonalváltásnál (az első betöltést az index.html-ben lévő alapkód követi)
  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }
    if (window.fbq) window.fbq("track", "PageView");
  }, [pathname]);

  useEffect(() => {
    if (hash) {
      const scroll = () => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
      // Korrekciós újragörgetés: a lazy képek betöltése elcsúsztathatja az oldalt
      setTimeout(scroll, 100);
      setTimeout(scroll, 800);
      setTimeout(scroll, 1600);
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

const AppShell = () => {
  const { pathname } = useLocation();

  // Színtéma: az admin felületen beállított érték a backendből
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/settings`)
      .then((res) => {
        document.documentElement.setAttribute("data-theme", res.data.theme || "green");
      })
      .catch(() => {
        document.documentElement.setAttribute("data-theme", "green");
      });
    initAnalytics();
  }, []);

  // Látogatottság: oldalmegtekintés minden útvonalváltásnál
  useEffect(() => {
    trackPageview(pathname);
  }, [pathname]);

  // A Munkáink és portfólió oldalak világos hátteret kapnak, hogy a képek és a fekete boxok kiemelkedjenek
  const isLight = pathname.startsWith("/munkaink") || pathname.startsWith("/portfolio");
  return (
    <div className={`min-h-screen ${isLight ? "bg-[var(--bg-light)]" : "bg-[var(--bg-dark)]"} text-white transition-colors duration-300`}>
      <ScrollManager />
      <Navbar light={isLight} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/munkaink" element={<Munkaink />} />
        <Route path="/portfolio/:category" element={<CategoryPage />} />
        <Route path="/portfolio/:category/:slug" element={<ProjectPage />} />
        <Route path="/rolunk" element={<Rolunk />} />
        <Route path="/koszonjuk" element={<ThankYou />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </div>
  );
}

export default App;
